import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const SuccessModal = ({ isOpen, toggle, contentName, platform }) => {
  // Generate unique IDs for accessibility
  const modalId = 'redemption-success-modal'
  const modalTitleId = 'redemption-success-title'

  // Determine the correct message ID based on platform
  const getPlatformMessageId = () => {
    switch (platform) {
      case 'uplay':
        return 'uPlay.label.success'
      case 'steam':
        return 'steam.label.success'
      case 'epic':
        return 'epic.label.success'
      case 'rc':
        return 'robotcache.label.success'
      default:
        return 'global.label.successGeneric'
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="global.label.success" />
        </h2>
        <p>
          <FormattedMessage id={getPlatformMessageId()} values={{ contentTitle: contentName }} />
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button block outline color="light" onClick={toggle} aria-label="Close this message">
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

SuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  contentName: PropTypes.string.isRequired,
  platform: PropTypes.oneOf(['uplay', 'steam', 'epic', 'rc']).isRequired,
}

export default SuccessModal
